var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-number-keyboard",style:({
    width: _vm.size + 'px',
    height: _vm.size + 'px'
  })},_vm._l((_vm.keys),function(key){return _c('div',{staticClass:"m-nkb-item",class:{'m-key-enter': key.val === 'enter'},style:([{
      width: (key.val === 0 ? _vm.size/2 : _vm.size/4) + 'px',
      height: (key.val === 'enter' ? _vm.size/2 : _vm.size/4) + 'px'
    }])},[_c('button',{staticClass:"m-key",attrs:{"data-val":key.val,"data-key":key.name,"disabled":_vm.disabledKeys.indexOf(key.name) > -1},on:{"click":function($event){return _vm.handleClick(key)}}},[_vm._v("\r\n      "+_vm._s(key.name)+"\r\n    ")])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b78dca1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/m/number-keyboard/number-keyboard.vue
// module id = HqgR
// module chunks = 87